module.exports = __webpack_public_path__ + "static/media/example-2.3e5925a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Koombana/example-2.jpg
// module id = 299
// module chunks = 0